export const tokenPath = (tokenId: Number) => `/punk/${tokenId}`;
